// extracted by mini-css-extract-plugin
export default {"contents":"AnalysisDetailScreen_contents__M7aDe","details":"AnalysisDetailScreen_details__iFQ+D","list":"AnalysisDetailScreen_list__3IIjZ"};